export default __webpack_public_path__ + "static/box-min-78f98f2847b4fd75c90e3b364efdae78.png";